import { AnimatePresence } from 'framer-motion'

import { useRewardGainQueue } from '@/features/wallet-movements/hooks/useRewardGainQueue'
import { useReducedMotion } from '@/shared/hooks/useReducedMotion'
import { RewardGainBadge } from '@/shared/ui/RewardGainBadge'

/**
 * Ancora a fila de badges de ganho no shell.
 *
 * Mora no `GameShell`, irmão da bottom nav e fora da página: troca de rota
 * remonta a página, e a fila não pode reiniciar no meio de um lote.
 *
 * A preferência de movimento é lida aqui e propagada por prop, para o
 * `RewardGainBadge` continuar puro.
 */
export const RewardGainBadgeHost = () => {
  const { batch, slot } = useRewardGainQueue()
  const reducedMotion = useReducedMotion()

  const visible = batch && slot
  const item = visible && slot.kind === 'item' ? batch.items[slot.index] : null
  const isOverflow = Boolean(visible && slot.kind === 'overflow')

  return (
    // `pointer-events-none` no wrapper: o badge se sobrepõe ao conteúdo e não
    // pode capturar toque de quem está lendo a página por baixo dele.
    // `--gami-bottom-nav-clearance` é o mesmo afastamento que o app já usa para
    // a barra, então o badge acompanha a safe area do iOS de graça.
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed right-3 z-reward-gain flex justify-end"
      style={{ bottom: 'calc(var(--gami-bottom-nav-clearance) + 8px)' }}
    >
      <AnimatePresence mode="wait">
        {item && (
          <RewardGainBadge
            key={`item-${item.movementId}`}
            points={item.points}
            coins={item.coins}
            reducedMotion={reducedMotion}
          />
        )}
        {isOverflow && batch && (
          <RewardGainBadge
            key={`overflow-${batch.ackId}`}
            overflowCount={batch.overflowCount}
            reducedMotion={reducedMotion}
          />
        )}
      </AnimatePresence>
    </div>
  )
}

RewardGainBadgeHost.displayName = 'RewardGainBadgeHost'
